//Javascript for the WECAN Employer Vacancy List
app.QuestionSet = (
    function () {
        var questionSets = {
            //Index Page
            Index: function () {

                var titleInUseInput = $('#TitleInUse');
                if (titleInUseInput.length > 0) {
                    // Check if the title is in use
                    var titleInUse = titleInUseInput.val() == 'True'; // Adjust the comparison value based on your actual value
                    if (titleInUse) {
                        // Check for the existence of each modal and display the appropriate one
                        if ($('#duplicateQuestionSet').length > 0) {
                            $('#duplicateQuestionSet').modal('show');
                        } else if ($('#addQuestionSet').length > 0) {
                            $('#addQuestionSet').modal('show');
                        }
                    }
                }

                checkTitles($('input[name="Title"]'));
                $(document).on("component-remove-complete-QuestionSets",
                    function() {
                        window.location.replace("/Employer/Question");
                    });
                $('input[name="Title"]').on('input', function () {
                    checkTitles(this);
                });

                function checkTitles(element) {
                    var titleValue = $(element).val().trim(); // Trim whitespace from the input value
                    // Get the existing title, trim it, and remove newline and carriage return characters
                    var existingTitle = $('#set-title').text().trim().replace(/[\n\r]/g, '');
                    var $continueButton = $('#continue-button');

                    // Enable the button if the titles do not match; otherwise, disable it
                    if (titleValue === existingTitle) {
                        $continueButton.prop('disabled', true);
                    } else {
                        $continueButton.prop('disabled', false);
                    }
                }
            }
        };

        return questionSets;
    }()
);